<h1 mat-dialog-title i18n>Search for a Bike</h1>
<form [formGroup]="formInputs">
	<div mat-dialog-content class="main-content px-3">
		<div class="row">
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Sr. No.</mat-label>
					<input matInput type="text" placeholder="bike id" i18n-placeholder formControlName="bikeId" />
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.bikeId"
						[type]="'text'"
					></mat-error>
				</mat-form-field>
			</div>

			<div class="col-6">
				<div class="col-12 text-right mb-4 mt-2">
					<button
						[disabled]="formInputs.invalid"
						type="submit"
						mat-flat-button
						color="primary"
						i18n
						(click)="findBikes()"
						class="col-12 col-sm-auto mr-sm-2"
					>Search</button>

					<button
						type="button"
						mat-flat-button
						color="warn"
						i18n
						(click)="close($event)"
						title="Close"
						i18n-title
						class="col-12 col-sm-auto mb-2 mb-sm-0 reset-button"
					>Close</button>
				</div>
			</div>
		</div>

		<div class="row" *ngIf="bikes && bikes.length">
			<div class="col-12">
				<mat-card class="p-0">
					<div class="table-responsive">
						<table
							mat-table
							[dataSource]="bikes"
							class="w-100"
							matSort
							matSortActive="{{sortColumn}}"
							matSortDisableClear
							matSortDirection="{{sortOrder}}"
							multiTemplateDataRows
							aria-label="List of available bikes">

							<ng-container matColumnDef="bikeUuid">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>ID</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<button (click)="viewBikeDetailsUsingId(row['bikeUuid'])" title="View Bike Details" class="button-link">{{row.bikeUuid}}</button>
								</td>
							</ng-container>

							<ng-container matColumnDef="serialNumber">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Serial Number</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<button (click)="viewBikeDetailsUsingSerialNumber(row['serialNumber'])" title="Serial Number" class="button-link">{{row.serialNumber}}</button>
								</td>
							</ng-container>

							<ng-container matColumnDef="model">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Model</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<span title="Model">{{row.model}}</span>
								</td>
							</ng-container>

							<ng-container matColumnDef="photoUrl">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Photo</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<img [src]="row.photoUrl" width="40" alt="Bike Photo"/>
								</td>
							</ng-container>

							<ng-container matColumnDef="isRegistered">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Registered?</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<span *ngIf="row.isRegistered">Y</span>
									<span *ngIf="!row.isRegistered">N</span>
								</td>
							</ng-container>

							<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
							<tr mat-row *matRowDef="let row; columns: tableColumns; let i = dataIndex;"></tr>
						</table>
					</div>
				</mat-card>
			</div>
		</div>
	</div>
</form>
